setTimeout(() => {
  if(BSS_B2B) {
    //cart-drawer
    const elem = document.querySelector("#drawer-cart");
    if(elem){
      const observer = new MutationObserver((MutationList) => {
        for(let item of MutationList){
          if(item.target.id === 'drawer-cart' || (item.target.attributes[0].nodeName === 'data-cart-form' && item.attributeName == 'class')){
            BSS_B2B.cart.fixer(BSS_B2B.shopData, false, false)
          }
        }
      })
      observer.observe(elem, {attributes: true, subtree: true, childList: true})
    }

    //cart
    if(window.location.pathname === '/cart'){
      const elem = document.querySelector(".cart__template");
      if(elem){
        const observer = new MutationObserver((MutationList) => {
          for(let item of MutationList){
            if(item.target.class === 'wrapper'){
              BSS_B2B.cart.fixer(BSS_B2B.shopData, false, false)
            }
          }
        })
        observer.observe(elem, {attributes: true, subtree: true, childList: true})
      }
      
    }
  }
}, 300)

let timeBack = 10;
const handleF = () => {
  try {
    const target = $(".shopify-product-form .form__selectors label");  
    if (target.length > 0) {
      $(target).on("click", () => {
        setTimeout(() => {
            const urlParams = new URLSearchParams(new URL(window.location.href).search);
            const variantValue = urlParams.get('variant');
            console.log(variantValue);
  BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), "[bss-b2b-variant-id]", false, false, variantValue);
        }, 200)
      })
    }
    else if (timeBack-- > 0) setTimeout(handleF, 300);
  } catch (error) {
    if (timeBack-- > 0) setTimeout(handleF, 300);
  }
}
handleF();
